import styled from '@emotion/styled';
import React from 'react';

import { layoutDeprecatedWarning } from '../../console-messages';
import type { ResponsiveType } from '../../types';
import { getSize, getAlignmentStyles } from '../../utilities';

const alignments = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

type Alignments = 'start' | 'center' | 'end' | 'stretch';
type LayoutProps = {
  alignment?: Alignments | Alignments[];
  gap?: ResponsiveType<string | number>;
  children?: React.ReactNode;
};

type LayoutSectionProps = {
  width?: ResponsiveType<string | number>;
  maxWidth?: ResponsiveType<string | number>;
  children?: React.ReactNode;
};

const LayoutWrapper = styled.div<LayoutProps>`
  display: flex;
  ${props => getAlignmentStyles(props.alignment, alignments)};

  & > * + * {
    ${props => props.gap && getSize('margin-left', props.gap)};
  }
`;

const LayoutSectionWrapper = styled.div<LayoutSectionProps>`
  min-width: 0px;
  flex-shrink: 0;
  ${props => getSize('width', props.width)};
  ${props => getSize('max-width', props.maxWidth)};
  ${props => (props.width ? `flex-shrink: 0` : `flex: 1 1 0%`)};
`;

export const LayoutSection = ({
  width,
  maxWidth,
  children,
  ...props
}: LayoutSectionProps & React.ComponentProps<typeof LayoutSectionWrapper>) => {
  // eslint-disable-next-line no-console
  console.warn(layoutDeprecatedWarning);

  return (
    <LayoutSectionWrapper width={width} maxWidth={maxWidth} {...props}>
      {children}
    </LayoutSectionWrapper>
  );
};

const Layout: React.FC<LayoutProps> & {
  Section: typeof LayoutSection;
} = props => {
  // eslint-disable-next-line no-console
  console.warn(layoutDeprecatedWarning);

  return <LayoutWrapper {...props}>{props.children}</LayoutWrapper>;
};

// Preserve the `Layout.Section` static-member API of the previous class
// component so existing call sites (`<Layout.Section ... />`) keep working.
Layout.Section = LayoutSection;

export default Layout;
